import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../../@types/RootState';

export type RulesPageFiltersDataState = Record<string, DataItem[]>;

const initialState: RulesPageFiltersDataState = {};

const slice = createSlice({
  name: 'ipa.strategy.rules.filters.data',
  initialState,
  reducers: {
    RESET_RULES_PAGE_FILTERS_DATA: () => initialState,
    SET_RULES_FILTERS_DATA_BY_KEY: (
      state,
      action: PayloadAction<{
        key: keyof RulesPageFiltersDataState;
        data: DataItem[];
      }>,
    ) => {
      return {
        ...state,
        [action.payload.key]: action.payload.data,
      };
    },
  },
});

export const selectorRulesPageFiltersData = (state: RootState) => state.ipa.strategy.rules.filters.data;

export const { RESET_RULES_PAGE_FILTERS_DATA, SET_RULES_FILTERS_DATA_BY_KEY } = slice.actions;

export default slice.reducer;
